
import { defineComponent } from 'vue';
import HomeContent from '../components/home/HomeContent.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    HomeContent
  },
});
